<template lang="pug">
.RoutineResultPage
  .content(@click="handleContentClick")
    .title(:class="{ zoom: this.isAppear, pop: this.shootCount === this.routineResult.comboCount }")
      | {{shootCount}}日継続
      span(v-if="this.shootCount === this.routineResult.comboCount") ！
    .background(ref="backgroundRef")
      km-fireworks-artwork

  km-footer(
    title="ルーティーン"
    backPath="/routine/top"
  )

</template>

<script>
import { mapState } from 'vuex'
// import soundService from '@/services/SoundService'
import FireworksArtwork from '@/components/shared/FireworksArtwork'

export default {
  name: 'routine-result-page',
  components: {
    'km-fireworks-artwork': FireworksArtwork
  },
  computed: {
    ...mapState('User', {
      rank: state => state.rank,
      lvl: state => state.lvl,
      exp: state => state.exp,
      progress: state => state.progress,
      point: state => state.point,
      account: state => state.account,
      challengeResult: state => state.challenge_result,
      routineResult: state => state.routine_result
    })
  },
  data() {
    return {
      isAppear: false,
      shootCount: 0,
      fireTimerInstance: null
    }
  },
  methods: {
    shoot() {
      if (this.shootCount < this.routineResult.comboCount) {
        this.$eventbus.$emit('fireworksArtwork.shootFirework')
        this.shootCount++
      } else {
        if (this.fireTimerInstance) {
          clearInterval(this.fireTimerInstance)
          this.fireTimerInstance = null
        }
      }
    },
    startbackgroundAnimation() {
      this.shoot()
      this.fireTimerInstance = setInterval(() => {
        this.shoot()
      }, 723 * 4)
    },
    handleStartButtonClick() {
      this.$router.push('/routine/player')
    },
    handleContentClick() {
      this.shoot()
    }
  },
  mounted() {
    this.remainCount = this.routineResult.comboCount
    this.startbackgroundAnimation()
    setTimeout(() => {
      this.isAppear = true
    }, 100)
  },
  beforeDestroy() {
    clearInterval(this.fireTimerInstance)
  }
}
</script>

<style lang="scss" scoped>
.RoutineResultPage {
  width: 100%;
  height: 100%;
}

.content {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: calc(100% - 80px);
  color: #fff;
}

.title {
  display: inline-block;
  font-size: 10rem;
  opacity: 0.5;
  transform: scale(0.5);
  &.zoom {
    transform: scale(0.9);
    opacity: 0.8;
    transition: none 30s ease;
    transition-property: opacity, transform;
  }
  &.pop {
    transform: scale(1);
    opacity: 1;
    transition: none 0.5s ease;
    transition-property: opacity, transform;
  }
}

.background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: -1;
  overflow: hidden;
}
</style>
